// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5050":"5458bd3e","8070":"92edbb20"}[chunkId] + ".chunk.css";
};